import axios from 'axios';
import { getApiInstance } from '../api';

export const uploadProposalFiles = async ({
  token,
  proposalId,
  files,
}: {
  token: string;
  proposalId: string;
  files: FileList;
}) => {
  const api = getApiInstance(token);
  try {
    const formData = new FormData();

    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }

    await api.put(`/proposals/files/${proposalId}`, formData, {
      headers: {
        'Content-Type': `multipart/form-data`,
      },
    });

    return { success: true };
  } catch (error) {
    console.error(error);

    if (axios.isAxiosError(error) && error.response?.status) {
      return {
        success: false,
        message: `Erro ao carregar arquivos. ${error.response?.data.message}`,
      };
    }

    return {
      success: false,
      message: `Erro ao carregar arquivos. Erro desconhecido: ${
        (error as Error).message
      }`,
    };
  }
};
